import styled, { css } from 'styled-components';

export const HeaderTools = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderTool = styled.div`
  width: 16px;
  height: 16px;
  opacity: 0.6;
  transition: 0.2s opacity ease;
  background-repeat: no-repeat;
  display: block;
  cursor: pointer;

  &:hover,
  &:focus {
    opacity: 1;
    transition: 0.2s opacity ease;
  }

  ${({ src }) =>
    src &&
    css`
      background-image: url(${src});
    `}
`;

export const FullScreenHeaderTool = styled(HeaderTool)`
  margin: 0 18px 0 0;
`;

export const DyslexicFontHeaderTool = styled(HeaderTool)``;

export const CloseHeaderTool = styled(HeaderTool)`
  background-size: 18px 18px;
  height: 18px;
  width: 18px;
  margin: 0 0 0 25px;
`;
